module.exports = __webpack_public_path__ + "static/media/YF81_2.ec8cdf1b.jpg";